import { OnInit, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { PracticeService } from '../../../services/practice.service';
import { Normative } from '../../../model/normative';

@Component({
  selector: 'app-normative-dialog',
  templateUrl: 'normative-dialog.component.html',
  styleUrls: ['./normative-dialog.component.css']
})

export class NormativeDialogComponent {

  loading: boolean;
  practiceNormative: string;
  planNormative: string;
  entityNormative: string;

  visualizePracticeNormative: boolean;
  visualizePlanNormative: boolean;
  visualizeEntityNormative: boolean;

  constructor(private practiceService: PracticeService
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<NormativeDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: Normative) {
    this.practiceNormative = data.PracticeNormative;
    this.planNormative = data.PlanNormative;
    this.entityNormative = data.EntityNormative;
    this.visualizePracticeNormative = data.VisualizePracticeNormative;
    this.visualizePlanNormative = data.VisualizePlanNormative;
    this.visualizeEntityNormative = data.VisualizeEntityNormative;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
